import { PpaLabel } from '@ori/presentation-components';
import { Skeleton, styled } from '@ori-ui/mui';
import { FONT_SANS_ORI } from "../common";
export var ProductBoxRoot = styled('a')(function (_ref) {
  var theme = _ref.theme;
  return {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: FONT_SANS_ORI,
    gap: theme.spacing(2),
    textDecoration: 'none',
    '& *': {
      boxSizing: 'border-box'
    },
    '&:hover': {
      color: theme.palette.text.secondary
    },
    '&:hover .imageZoom': {
      transform: 'translate(-50%, -50%) scale(1.1)'
    },
    '&:focus': {
      color: theme.palette.text.secondary
    },
    '&:active': {
      color: theme.palette.text.secondary
    }
  };
});
export var Ppa = styled(PpaLabel)({
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px'
});
export var ImageWrapper = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    position: 'relative',
    height: 0,
    paddingTop: '100%',
    overflow: 'hidden',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    background: theme.palette.grey[100]
  };
});
export var NamesWrapper = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'grid',
    gap: theme.spacing(1)
  };
});
export var Brand = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.grey.A700,
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(10),
    letterSpacing: 2,
    lineHeight: theme.spacing(3),
    overflow: 'hidden',
    textAlign: 'left',
    textTransform: 'uppercase',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    width: '100%'
  };
});
export var Name = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.palette.text.primary,
    display: '-webkit-box',
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.spacing(4),
    overflow: 'hidden',
    textAlign: 'left',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    width: '100%'
  };
});

// Disable 'transform' which may ori-ui/mui skeleton have
export var BasicSkeleton = styled(Skeleton)({
  transform: 'none'
});
//# sourceMappingURL=styles.js.map